import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(complexDenominator, c1, c2, r1, r2, sImaginary) {
  var result = Complex.createComplex(r2, r2 * r1 * sImaginary * (c1 + c2)).divide(complexDenominator);
  return result;
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
